import moment from "moment"
moment.locale("zh-cn")
import {getList,addBGzhangdan,updateBGzhangdan,deleteBGzhangdan} from "@/api/baogongzhangdan.js"


let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)
let dd1 = localStorage.getItem("date1"),dd2=localStorage.getItem("date2")

const request = {
	"get":getList,
	"add":addBGzhangdan,
	"update":updateBGzhangdan,
	"delet":deleteBGzhangdan,
	'handleData':(data)=>{
		data = new Proxy(data,{
			get(target,key){
				if(moment.isMoment(target[key])){
					return target[key].format("YYYY-MM-DD")
				}
				if(key == "roominfo"||key=="butieinfo"||key =="kouchuinfo"||key=="priceinfo"){
					return JSON.stringify(target[key])
				}
				return target[key]
			}
			})
		return {...data}
	}
}


const searchData = getSearchParm({
	name:"",
	idcard:"",
	banknum:"",
	group:"",
	workplace:"",
	roomtype:"",
	starttime:dd1,
	endtime:dd2,
	cmpid:user.cmpid
})



export function getSearchParm(obj){
    return new Proxy(obj,{
        get(target,key){
            if(target[key] == ""||target==null){
                return undefined
            }
		    if((key == "starttime"||key=="endtime") && moment.isMoment(target[key])){
				return target[key].format("YYYY-MM-DD"); 
		    }
			return target[key]
	    }
    })
}

const columns = [
    {dataIndex:"id",key:"id",title:"序号",scopedSlots: { customRender: 'tindex' }},
    {dataIndex:"starttime",key:"starttime",title:"开始时间"},
    {dataIndex:"endtime",key:"endtime",title:"结束时间"},
    {dataIndex:"idcard",key:"idcard",title:"身份证号码"},
    {dataIndex:"workplace",key:"workplace",title:"所属工地",width:"100px",
		myRender:"workplace",scopedSlots: { customRender: 'workplace' }
    },
    {dataIndex:"name",key:"name",title:"姓名",width:"100px"},
    {dataIndex:"banknum",key:"banknum",title:"银行卡号"},
    {dataIndex:"group",key:"group",title:"所属班组",width:"170px",},
    {dataIndex:"yingfu",key:"yingfu",title:"应付金额"},
    {dataIndex:"kouyuzhi",key:"kouyuzhi",title:"预支金额",width:"100px"},
    {dataIndex:"koufafang",key:"koufafang",title:"项目发放",width:"100px"},
    {dataIndex:"jieyu",key:"jieyu",title:"结余金额"},
    {dataIndex:"shifoufafang",key:"shifoufafang",title:"是否发放",width:"100px",
		myRender:"shifoufafang",scopedSlots: { customRender: 'shifoufafang' }
    },
    {key:"action",title:"操作",scopedSlots:{customRender:"action"},width:'200px'}
]

const excelheader = {
	"所属工地":"workplace",
	"日薪类型":"type1",
	"日薪":"price1",
	"上班天数":"num1",
	"日薪总价":"sum1",
	"房屋类型":"type2",
	"单价":"price2",
	"面积":"num2",
	"房屋总价":"sum2",
	"补贴说明":"note3",
	"补贴金额":"num3",
	"扣除说明":"note4",
	"扣除金额":"num4",
}
export const comdata = {
	columns,
	excelheader,
	workplaceArray:[],
	roomtypeArray:[],
	request,
	searchData,
	formData:{
	}
}